import prizeAllocationDialog from './prizeAllocationDialog.container'

export default prizeAllocationDialog